import { languages_config } from '@acri-tools/react-tools/languages';

export default {
    'en': {
        ...languages_config.languages['en'],
        ...require('./en.json')
    },
}